import React from "react";
import logo from "../../../../../assets/images/Carousels.jpg"

const SlideShow = () => {
  return (
    <div><div className="media-display-layout">
      {logo && <img src={logo} alt="Logo" className="st-profile-logo"style={{width: "100%", height: "100%"}}/>}
    </div>
    <div className="slideshow" style={{color: "darkgray"}}>🎥 Slideshow / Carousel View</div>
    </div>
  );
};

export default SlideShow;
